import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles(() => ({
  dialog: {
    width: "640px",
  },
  previewContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: 0,
  },
  title: {
    textAlign: "center",
  },
  body: {
    textAlign: "center",
  },
  obSummary: {
    padding: "24px",

    "& .MuiCardContent-root": {
      padding: "1.25rem 3rem",
    },
  },
  imageContainer: {
    padding: "20px",
    maxWidth: "144px",
    maxHeight: "144px",
    margin: "0 auto",
  },
  image: {
    maxWidth: "144px",
    maxHeight: "144px",
    objectFit: "cover",
  },
  video: {
    padding: "1rem",
    justifyContent: "center",
    alignItems: "center",
    width: "450px",
    height: "250px",
    margin: "0 auto",
  },
}));
